import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import {
  getVendorWorkOrderList_action,
  deleteVendorWorkOrder_action,
} from "../../../actions/admin_module_action/vendor_action/vendorWorkOrder_action/vendorWorkOrder_action";
import { getVendorStaticList_action } from "../../../actions/vendor_module_action/vendor_order_action";
import { exhibitionId, toastError } from "../../../utils/constants";
import Select from "react-select";

const styles = {
  width: "100%",
};

class VendorStaticList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      vendorStaticList: [],
      currentPage: 1,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      sortField: "",
      sortOrder: "",
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7,
      selectedHall: null,
      selectedService: null,
      companyFilter: "",
      showVideoModal: false,
    };
    this.updateItem = this.updateItem.bind(this);
  }

  componentDidMount() {
    this.getFillList(exhibitionId, "", "", "", "", "");
    this.getVendorStaticList();
  }

  getVendorStaticList() {
    const { ExhibitionID } = this.state;
    this.setState({ isLoading: true });
    try {
      this.props
        .getVendorStaticList_action(ExhibitionID)
        .then((data) => {
          if (data.error != 1) {
            console.log("Service Partner static list:", data.data);
            this.setState({
              vendorStaticList: data.data.vendorBasicDetail || [],
            });
          } else {
            toastError(data.msg);
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } catch {
      toastError("Something went wrong!");
      this.setState({ isLoading: false });
    }
  }

  updateItem(item) {
    const { vendorStaticList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = vendorStaticList.slice(
      indexOfFirstRecord,
      indexOfLastRecord,
    );
    const nPages = Math.ceil(vendorStaticList.length / recordsPerPage);
  }

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID,
  ) {
    const {} = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID,
      )
      .then((data) => {
        if (data.error != 1) {
          // voucher list
          if (actionID === exhibitionId) {
            // console.log("voucher type data", data.data)
            this.setState({
              exhibitionList: data.data,
              isLoading: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  clearValue() {
    this.setState({
      ExhibitionID: "",
    });

    setTimeout(() => {
      this.getVendorStaticList();
    }, 100);
  }

  handleSort = (field) => {
    const { sortField, sortOrder, vendorStaticList } = this.state;
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";

    const sortedData = [...vendorStaticList].sort((a, b) => {
      const aVal = a[field];
      const bVal = b[field];

      // Handle numbers vs strings
      if (typeof aVal === "number" && typeof bVal === "number") {
        return newSortOrder === "asc" ? aVal - bVal : bVal - aVal;
      }

      const aStr = (aVal || "").toString().toLowerCase();
      const bStr = (bVal || "").toString().toLowerCase();

      if (aStr < bStr) return newSortOrder === "asc" ? -1 : 1;
      if (aStr > bStr) return newSortOrder === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      vendorStaticList: sortedData,
      sortField: field,
      sortOrder: newSortOrder,
    });
  };

  getFilteredData() {
    const { vendorStaticList, selectedHall, selectedService, companyFilter } =
      this.state;
    return vendorStaticList.filter((vendor) => {
      const hallMatch = !selectedHall || vendor.HallName === selectedHall.value;
      const serviceMatch =
        !selectedService || vendor.ServiceName === selectedService.value;
      const companyMatch =
        !companyFilter ||
        (vendor.CompanyName || "")
          .toLowerCase()
          .includes(companyFilter.toLowerCase());
      return hallMatch && serviceMatch && companyMatch;
    });
  }

  getGroupedData() {
    const filteredData = this.getFilteredData();
    const grouped = {};

    filteredData.forEach((vendor) => {
      const key = `${vendor.HallName || "N/A"}_${vendor.ServiceName || "N/A"}`;
      if (!grouped[key]) {
        grouped[key] = {
          hallName: vendor.HallName || "N/A",
          serviceName: vendor.ServiceName || "N/A",
          vendors: [],
        };
      }

      const vendorKey = `${vendor.CompanyName}_${vendor.VendorPersonName}_${vendor.MobileNo}`;
      const existingVendor = grouped[key].vendors.find(
        (v) =>
          `${v.CompanyName}_${v.VendorPersonName}_${v.MobileNo}` === vendorKey,
      );

      if (existingVendor) {
        if (vendor.SubContractorCompanyName) {
          if (!existingVendor.subContractors) {
            existingVendor.subContractors = [];
          }
          existingVendor.subContractors.push({
            SubContractorCompanyName: vendor.SubContractorCompanyName,
            SubContractorPersonName: vendor.SubContractorPersonName,
            SubContractorMobileNo: vendor.SubContractorMobileNo,
            SubcontractorEmailID: vendor.SubcontractorEmailID,
          });
        }
        if (vendor.HallManagerCompanyName) {
          if (!existingVendor.hallManagers) {
            existingVendor.hallManagers = [];
          }
          existingVendor.hallManagers.push({
            HallManagerCompanyName: vendor.HallManagerCompanyName,
            HallManagerPersonName: vendor.HallManagerPersonName,
            HallManagerMobileNo: vendor.HallManagerMobileNo,
            HallManagerEmailID: vendor.HallManagerEmailID,
          });
        }
      } else {
        const vendorData = { ...vendor };
        if (vendor.SubContractorCompanyName) {
          vendorData.subContractors = [
            {
              SubContractorCompanyName: vendor.SubContractorCompanyName,
              SubContractorPersonName: vendor.SubContractorPersonName,
              SubContractorMobileNo: vendor.SubContractorMobileNo,
              SubcontractorEmailID: vendor.SubcontractorEmailID,
            },
          ];
        }
        if (vendor.HallManagerCompanyName) {
          vendorData.hallManagers = [
            {
              HallManagerCompanyName: vendor.HallManagerCompanyName,
              HallManagerPersonName: vendor.HallManagerPersonName,
              HallManagerMobileNo: vendor.HallManagerMobileNo,
              HallManagerEmailID: vendor.HallManagerEmailID,
            },
          ];
        }
        grouped[key].vendors.push(vendorData);
      }
    });

    return Object.values(grouped);
  }

  renderVendorStaticGrid() {
    const {
      sortField,
      sortOrder,
      selectedHall,
      selectedService,
      companyFilter,
      isVendor,
      vendorStaticList,
    } = this.state;
    const groupedData = this.getGroupedData();
    const roleID = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;

    const hallOptions = [
      ...new Set(vendorStaticList.map((vendor) => vendor.HallName)),
    ]
      .filter(Boolean)
      .map((hall) => ({ value: hall, label: hall }));

    const serviceOptions = [
      ...new Set(vendorStaticList.map((vendor) => vendor.ServiceName)),
    ]
      .filter(Boolean)
      .map((service) => ({ value: service, label: service }));

    return (
      <>
        <div
          className="mx-2 pt-2"
          style={{ zIndex: "0", position: "relative" }}
        >
          <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
            <Select
              value={selectedHall}
              onChange={(option) => this.setState({ selectedHall: option })}
              options={hallOptions}
              placeholder="Filter by Hall / Location"
              isClearable
              menuPortalTarget={document.body} 
              menuPosition="fixed" 
              styles={{
                container: (base) => ({ ...base, minWidth: "180px" }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
            <Select
              value={selectedService}
              onChange={(option) => this.setState({ selectedService: option })}
              options={serviceOptions}
              placeholder="Filter by Service"
              isClearable
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                container: (base) => ({ ...base, minWidth: "180px" }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Filter by Company Name"
              value={companyFilter}
              onChange={(e) => this.setState({ companyFilter: e.target.value })}
              style={{ minWidth: "180px", maxWidth: "200px" }}
            />
          </div>
        </div>
        <div className="pt-1 row m-0 p-2">
          <div className="table-responsive px-1 sticky-table-wrapper service-list-grid">
            <table className="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
              {/* <table
            className="table table-responsive border text-nowrap text-md-nowrap table-bordered p-0 mb-0 mt-1"
            style={{
              height: "calc(100vh - 330px)",
              overflow: "auto"
            }}
          > */}

              <thead className="table-light">
                <tr>
                  <th
                    className="text-left"
                    style={{ cursor: "pointer", width: "5%" }}
                    onClick={() => this.handleSort("HallName")}
                  >
                    Hall / Location Name
                    {sortField === "HallName" && (
                      <i
                        className={`fa fa-sort-${
                          sortOrder === "asc" ? "up" : "down"
                        } ms-1`}
                      ></i>
                    )}
                  </th>
                  <th
                    className="text-left"
                    style={{ cursor: "pointer", width: "15%" }}
                    onClick={() => this.handleSort("ServiceName")}
                  >
                    Service
                    {sortField === "ServiceName" && (
                      <i
                        className={`fa fa-sort-${
                          sortOrder === "asc" ? "up" : "down"
                        } ms-1`}
                      ></i>
                    )}
                  </th>

                  <th className="text-left" style={{ width: "auto" }}>
                    Service Partner Detail
                  </th>
                </tr>
              </thead>

              <tbody>
                {groupedData.length > 0 ? (
                  groupedData.map((group, index) => (
                    <tr key={index}>
                      <td
                        className="text-left"
                        style={{ width: "5%", verticalAlign: "top" }}
                      >
                        {group.hallName}
                      </td>

                      <td
                        className="text-left"
                        style={{ width: "15%", verticalAlign: "top" }}
                      >
                        {group.serviceName}
                      </td>

                      {/* LAST COLUMN AUTO EXPAND */}
                      <td style={{ width: "auto", padding: "8px" }}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          {group.vendors.map((vendor, vendorIndex) => (
                            <div
                              key={vendorIndex}
                              style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "6px",
                                padding: "8px",
                                paddingTop: "1px",
                                backgroundColor: "#f9f9f9",
                                minWidth: "250px",
                                flex: "1 1 calc(50% - 4px)",
                              }}
                            >
                              {!isVendor && (
                                <div style={{ marginBottom: "4px" }}>
                                  <span
                                    className={`badge ${vendor.IsEmpanelVendor === "Yes" ? "bg-aqua" : "bg-aqua"}`}
                                    style={{
                                      fontSize: "10px",
                                      marginRight: "6px",
                                    }}
                                  >
                                    {vendor.IsEmpanelVendor === "Yes"
                                      ? "Empanel"
                                      : "Non-Empanel"}
                                  </span>
                                </div>
                              )}

                              <div>
                                <i className="fa fa-building-o grid-icon"></i>
                                <span className="">
                                  {vendor.CompanyName || "N/A"}
                                </span>
                              </div>

                              {!isVendor &&
                                vendor.IsEmpanelVendor === "No" &&
                                vendor.StallName && (
                                  <div>
                                    <i className="fa fa-building grid-icon"></i>
                                    <span>{vendor.StallName}</span>
                                  </div>
                                )}

                              <div>
                                <i className="fa fa-user grid-icon"></i>
                                <span>{vendor.VendorPersonName || "N/A"}</span>
                              </div>

                              <div>
                                <i className="fa fa-phone grid-icon"></i>
                                <span>{vendor.MobileNo || "N/A"}</span>
                              </div>

                              <div>
                                <i className="fa fa-envelope grid-icon"></i>
                                <span style={{ wordBreak: "break-all" }}>
                                  {vendor.PrimaryEmail || "N/A"}
                                </span>
                              </div>

                              {vendor.subContractors &&
                                vendor.subContractors.length > 0 && (
                                  <div className="subcontractor-wrapper">
                                    <div className="subcontractor-title">
                                      Sub-Contractor
                                      {vendor.subContractors.length > 1
                                        ? "s"
                                        : ""}
                                      :
                                    </div>

                                    {vendor.subContractors.map(
                                      (sub, subIndex) => (
                                        <div
                                          key={subIndex}
                                          className={`subcontractor-item ${
                                            subIndex <
                                            vendor.subContractors.length - 1
                                              ? "with-border"
                                              : ""
                                          }`}
                                        >
                                          <div className="subcontractor-row">
                                            <i className="ri-hotel-line icon-muted"></i>
                                            <span>
                                              {sub.SubContractorCompanyName}
                                            </span>
                                          </div>

                                          {sub.SubContractorPersonName && (
                                            <div className="subcontractor-row">
                                              <i className="fa fa-user icon-muted"></i>
                                              <span>
                                                {sub.SubContractorPersonName}
                                              </span>
                                            </div>
                                          )}

                                          {sub.SubContractorMobileNo && (
                                            <div className="subcontractor-row">
                                              <i className="fa fa-phone icon-muted"></i>
                                              <span>
                                                {sub.SubContractorMobileNo}
                                              </span>
                                            </div>
                                          )}

                                          {sub.SubcontractorEmailID && (
                                            <div className="subcontractor-row">
                                              <i className="fa fa-envelope icon-muted"></i>
                                              <span className="break-all">
                                                {sub.SubcontractorEmailID}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      ),
                                    )}
                                  </div>
                                )}

                              {vendor.hallManagers &&
                                vendor.hallManagers.length > 0 && (
                                  <div className="subcontractor-wrapper">
                                    <div className="subcontractor-title">
                                      Team Member
                                      {vendor.hallManagers.length > 1
                                        ? "s"
                                        : ""}
                                      :
                                    </div>

                                    {vendor.hallManagers.map(
                                      (hall, hallIndex) => (
                                        <div
                                          key={hallIndex}
                                          className={`subcontractor-item ${
                                            hallIndex <
                                            vendor.hallManagers.length - 1
                                              ? "with-border"
                                              : ""
                                          }`}
                                        >
                                          {/* <div className="subcontractor-row">
                                        <i className="ri-hotel-line icon-muted"></i>
                                        <span>{hall.HallManagerCompanyName}</span>
                                      </div> */}

                                          {hall.HallManagerPersonName && (
                                            <div className="subcontractor-row">
                                              <i className="fa fa-user grid-icon"></i>
                                              <span>
                                                {hall.HallManagerPersonName}
                                              </span>
                                            </div>
                                          )}

                                          {hall.HallManagerMobileNo && (
                                            <div className="subcontractor-row">
                                              <i className="fa fa-phone grid-icon"></i>
                                              <span>
                                                {hall.HallManagerMobileNo}
                                              </span>
                                            </div>
                                          )}

                                          {hall.HallManagerEmailID && (
                                            <div className="subcontractor-row">
                                              <i className="fa fa-envelope grid-icon"></i>
                                              <span className="break-all">
                                                {hall.HallManagerEmailID}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      ),
                                    )}
                                  </div>
                                )}
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted py-4">
                      No vendor data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* </div> */}
      </>
    );
  }

  render() {
    const {
      isLoading,
      vendorStaticList,
      isVendor,
      currentPage,
      showVideoModal,
    } = this.state;

    console.log("vendorStaticList", vendorStaticList);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {isVendor && showVideoModal && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => this.setState({ showVideoModal: false })}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Service Partner List</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.setState({ showVideoModal: false })}
                  ></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: "100%" }}>
                    <source
                      src="/assets/VendorServicePartnerList.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        <div
          className={`main-content ${JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? "exb-top-space-2" : "admin-top-space"}`}
          style={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? {
                  marginLeft: "200px",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                }
              : {}
          }
        >
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorDrawer />
          ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 ? (
            <VendorDrawer />
          ) : (
            <AdminDrawer />
          )}
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorTopMenu />
          ) : null}
          {isVendor && (
            <div className="d-flex justify-content-end px-2 pt-3 text-aqua">
              <span
                onClick={() => this.setState({ showVideoModal: true })}
                style={{
                  cursor: "pointer",
                  color: "#3dbca7",
                  fontSize: "16px",
                  marginLeft: "auto",
                }}
              >
                <i className="bi bi-play-circle-fill me-2"></i>User Manual
              </span>
            </div>
          )}
          {this.renderVendorStaticGrid()}
        </div>
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container exb-side-space"
              : "with-dr-container com-height"
          }
          style={{ margin: isVendor ? 0 : "" }}
        ></div>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getVendorStaticList_action,
  })(VendorStaticList),
);
